import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-refresh-table-button',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule],
  template: `
    <div style="display: flex; flex-direction: column; align-items: center;">
      <!-- Botón normal -->
      <button 
        *ngIf="cooldown === 0"
        pButton 
        pRipple 
        icon="pi pi-refresh"
        class="p-button-rounded p-button-info mr-2 refresh-btn" 
        (click)="onRefresh()" 
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        [attr.title]="tooltip"
      ></button>
      
      <!-- Botón con cooldown - HTML puro -->
      <div *ngIf="cooldown > 0" class="custom-refresh-button">
        <button 
          class="refresh-btn-disabled"
          [disabled]="true"
          [attr.aria-label]="ariaLabel"
          [attr.title]="'Espera ' + cooldown + 's para volver a refrescar'"
        >
          <i class="pi pi-refresh"></i>
        </button>
        <div class="cooldown-indicator">
          <span>{{cooldown}}</span>
        </div>
      </div>
      
      <small *ngIf="cooldown > 0" class="cooldown-message">Refrescar deshabilitado, espera {{cooldown}}s…</small>
    </div>
  `,
  styles: [`
    .refresh-btn {
      width: 26px !important;
      height: 26px !important;
    }
    
    .custom-refresh-button {
      position: relative;
      display: inline-block;
    }
    
    .refresh-btn-disabled {
      width: 26px;
      height: 26px;
      min-width: 26px;
      min-height: 26px;
      max-width: 26px;
      max-height: 26px;
      border-radius: 50%;
      border: none;
      background: #17a2b8;
      color: white;
      cursor: not-allowed;
      opacity: 0.8;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.875rem;
      transition: all 0.2s ease;
      padding: 0;
      margin: 0;
    }
    
    .refresh-btn-disabled:hover {
      background: #17a2b8;
      opacity: 0.8;
      width: 36px;
      height: 36px;
      transform: none;
    }
    
    .refresh-btn-disabled:active {
      width: 26px;
      height: 26px;
      transform: none;
    }
    
    .cooldown-indicator {
      position: absolute;
      top: -6px;
      right: -6px;
      background: #dc3545;
      color: white;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.6rem;
      font-weight: bold;
      border: 1.5px solid white;
      box-shadow: 0 1px 3px rgba(0,0,0,0.3);
      z-index: 10;
    }
    
    .cooldown-message {
      color: #888;
      margin-top: 0.25rem;
      font-size: 0.75rem;
      text-align: center;
    }
  `]
})
export class RefreshTableButtonComponent {
  @Output() refresh = new EventEmitter<void>();
  @Input() cooldownSeconds = 3;
  @Input() disabled = false;
  @Input() tooltip = 'Refrescar tabla';
  @Input() ariaLabel = 'Refrescar tabla';

  cooldown = 0;
  private cooldownTimer: any;

  onRefresh() {
    if (this.cooldown > 0 || this.disabled) return;
    this.refresh.emit();
    this.cooldown = this.cooldownSeconds;
    this.cooldownTimer = setInterval(() => {
      this.cooldown--;
      if (this.cooldown <= 0) {
        clearInterval(this.cooldownTimer);
      }
    }, 1000);
  }
} 